export const TOOLBAR_IMAGE_CONSTS = {
  cancelMsg: 'Отмена',
  changeMsg: 'Изменить',
  deleteMsg: 'Удалить',
  insertingImageMsg: 'Вставка фото',
  pastePhotoMsg: 'Вставить фото',
  pasteGalleryMsg: 'Вставить галерею'
}
